import { useMemo, useRef } from 'react';
import { useAcademyChatActions } from '../../context/AcademyChatActionsContext';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { LearningContentCardsSkeleton } from 'academy-common-lib/components/Skeletons/LearningContentCardsSkeleton';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { LearningContentCard } from 'academy-common-lib/features/learningContentCard/components/LearningContentCard';
import { jsx as _jsx } from "react/jsx-runtime";
const parseAcademyVideoUrl = url => {
  var _searchParams$get, _searchParams$get2, _searchParams$get3;
  const {
    searchParams,
    pathname
  } = new URL(url);
  const segments = pathname.split('/');
  const vts = parseInt((_searchParams$get = searchParams.get('vts')) !== null && _searchParams$get !== void 0 ? _searchParams$get : '', 10);
  const vte = parseInt((_searchParams$get2 = searchParams.get('vte')) !== null && _searchParams$get2 !== void 0 ? _searchParams$get2 : '', 10);
  const clipRange = !isNaN(vts) && !isNaN(vte) ? {
    startTime: vts,
    endTime: vte
  } : undefined;
  let resourceId;
  let type;

  // Track URLs: /tracks/{courseId}/{lessonId}/{contentId}
  // The clip is from a specific lesson, so extract the lessonId (2nd segment)
  const tracksIdx = segments.indexOf('tracks');
  if (tracksIdx !== -1 && segments[tracksIdx + 2]) {
    resourceId = parseInt(segments[tracksIdx + 2], 10);
    type = 'LESSON';
  } else {
    const lessonsIdx = segments.indexOf('lessons');
    const shortIdx = segments.indexOf('shortvideo');
    if (lessonsIdx !== -1 && segments[lessonsIdx + 1]) {
      resourceId = parseInt(segments[lessonsIdx + 1], 10);
      type = 'LESSON';
    } else if (shortIdx !== -1 && segments[shortIdx + 1]) {
      resourceId = parseInt(segments[shortIdx + 1], 10);
      type = 'SHORT_FORM_CONTENT';
    }
  }
  return {
    resourceId,
    type,
    clipRange,
    language: (_searchParams$get3 = searchParams.get('language')) !== null && _searchParams$get3 !== void 0 ? _searchParams$get3 : undefined
  };
};
export const AcademyClipCard = ({
  section
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    onContentCardClick,
    onContentCardImpression
  } = useAcademyChatActions();
  const {
    resourceId,
    type,
    language,
    clipRange
  } = parseAcademyVideoUrl(section.url);
  const items = useMemo(() => {
    if (resourceId == null || isNaN(resourceId) || type == null) return [];
    return [{
      id: resourceId,
      type,
      language: type === 'LESSON' ? language === null || language === void 0 ? void 0 : language.toLowerCase() : undefined
    }];
  }, [resourceId, type, language]);
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items,
    skip: !items.length
  });
  const hasTrackedImpressionRef = useRef(false);
  if (cardModelsLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: "400",
      marginBlockEnd: isMobile ? '400' : undefined,
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(LearningContentCardsSkeleton, {
          skeletonCardSize: "small",
          use: "on-light",
          maxSkeletonListLength: 1
        })
      })
    });
  }
  if (cardModelsError || !(cardModels !== null && cardModels !== void 0 && cardModels.length)) {
    return null;
  }
  if (!hasTrackedImpressionRef.current && resourceId != null && type != null) {
    hasTrackedImpressionRef.current = true;
    onContentCardImpression(resourceId, type);
  }
  return /*#__PURE__*/_jsx(Flex, {
    marginBlockStart: "400",
    marginBlockEnd: isMobile ? '400' : undefined,
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      children: /*#__PURE__*/_jsx(LearningContentCard, {
        clipRange: clipRange,
        item: cardModels[0],
        size: "small",
        videoLength: 'duration' in cardModels[0] ? cardModels[0].duration : undefined,
        overviewType: "academy-assistant",
        onItemClick: () => {
          if (resourceId != null && type != null) {
            onContentCardClick(resourceId, type);
          }
        }
      })
    })
  });
};